import { useIntl } from "react-intl";

import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type UnclaimListConfirmationModalProps = Pick<YesNoModalProps, "onClickYes" | "onClickNo">;

export function AddToDroppingListConfirmationModal({
  onClickYes,
  onClickNo,
}: UnclaimListConfirmationModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.add-to-dropping-list-confirmation-modal.title",
      })}
      body={intl.formatMessage({
        id: "components.add-to-dropping-list-confirmation-modal.body",
      })}
      yesLabel={intl.formatMessage({
        id: "flows.inventory.restocking-list.pages.product-search.cta-button-label",
      })}
      noLabel={intl.formatMessage({
        id: "components.unclaim-list-confirmation-modal.no",
      })}
      isGrey
    />
  );
}
